export const COLUMN_COUNT = 3;

// 3개씩 그룹화된 행을 생성하는 유틸리티 함수
export const chunkArray = <T>(array: T[], size: number): T[][] => {
  const chunks: T[][] = [];
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }
  return chunks;
};
